import './plugins/prototype';

import Vue from 'vue'
import axios from 'axios'
import api from "./api";
import router from './router'
import store from './store'
import vuetify, { basicTheme } from './plugins/vuetify'
import './plugins/vue-dayjs';
import './plugins/vue-cookies';
import './plugins/vue-meta';

import App from './AppMain.vue'

import "./styles/index.scss";

Vue.prototype.$http = axios;
Vue.config.productionTip = false;

if(process.env.NODE_ENV == "production" && location.protocol != "https:") location.protocol = "https:";

api.v1.theme.get().then(({ theme: siteTheme }) => {
    
    Vue.prototype.$theme = siteTheme;
    
    new Vue({
        router,
        store,
        vuetify: vuetify(siteTheme || basicTheme),
        render: h => h(App)
    }).$mount('#app')
});